import React from 'react';

import './linkCard.scss';

const LinkCard = ({onClick, children, className = ''}) => {
  return <div onClick={onClick} className={`linkCard ${className} flex flex-col align-center justify-center`}>{children}</div>
}

export default LinkCard;